<template>
  <div>
    <h1>Past lessons</h1>
    <div class="container">
      <div
        class="row"
        v-for="(video, index) in archivedVideos"
        :key="index"
      >
        <div>
          <h5 class="text-left">
            <a
              data-toggle="collapse"
              :href="'#video' + index"
              role="button"
              aria-expanded="false"
              :aria-controls="'video' + index"
              class="blue-link"
            >• {{ parseDate(video.videoName) }} (click to expand)</a>
          </h5>
          <div class="collapse" :id="'video' + index">
            <div class="card card-body">
              <LessonVideo
                :videoSource="video.videoName"
                :notes="video.notes"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LessonVideo from '@/components/LessonVideo.vue'
import videos from '../videos'
export default {
  name: 'Archive',
  components: {
    LessonVideo
  },
  computed: {
    archivedVideos() {
      if (videos) {
        let lessonVideos = videos.slice(1)
        return lessonVideos
      }
      return []
    }
  },
  methods: {
    parseDate(videoTitle) {
      let titleDate = videoTitle.split('_')[0]
      let translatedDate = new Date(`${titleDate.substring(0, 4)}-${titleDate.substring(4, 6)}-${titleDate.substring(6)}T11:00:00`)
      translatedDate = translatedDate.toString()
      translatedDate = translatedDate.split('11:00:00')[0]
      return translatedDate
    }
  }
}
</script>